import { useEffect, useState } from 'react';

import codeKitchenBackground from '../assets/pictures/codekitchen_background.png';
import '../styles/WelcomeScreen.scss';

import brainChef from '../assets/pictures/small pics/brain_chef.png';
import dotty from '../assets/pictures/small pics/dotty.png';
import herb from '../assets/pictures/small pics/rabbit_gardener.png';
import monsieurMoustache from '../assets/pictures/small pics/cat_critic.png';
import octoBear from '../assets/pictures/small pics/bear_pastry_chef.png';
import patch from '../assets/pictures/small pics/rat_scooter.png';
import py from '../assets/pictures/small pics/snake_waiter.png';
import retsko from '../assets/pictures/small pics/retsko_red_panda.png';
import soapy from '../assets/pictures/small pics/capybara_dishwasher.png';
import tux from '../assets/pictures/small pics/penguin_sysadmin.png';
import cookie from '../assets/pictures/small pics/cookie.png';
import hot_chocolate from '../assets/pictures/small pics/hot_chocolate.png';






export default function WelcomeScreen() {

const [showHeading, setShowHeading] = useState(false);
const [isBlurred, setIsBlurred] = useState(false);
const [showBackground, setShowBackground] = useState(false);
const [showStaffMembers, setShowStaffMembers] = useState(false);
const [showEnterButton, setShowEnterButton] = useState(false);

useEffect(() => {

      const showBackgroundTimer = setTimeout(() => {
    setShowBackground(true);
  }, 100); 

    const blurAfter2Seconds = setTimeout(() => {
        setIsBlurred(true) 
    },1500
);



const showHeadingAfterBlur = setTimeout(() => {
        setShowHeading(true) 
    },3000);


const showStaffAfterHeading = setTimeout(() => {
    setShowStaffMembers(true);
}, 3500); 



  





  

const showEnterButtonAfterStaff = setTimeout(() => {
    setShowEnterButton(true);
}, 4500); 

   return () => {
    clearTimeout(blurAfter2Seconds);
    clearTimeout(showHeadingAfterBlur);
    clearTimeout(showBackgroundTimer);
    clearTimeout(showStaffAfterHeading);

    clearTimeout(showEnterButtonAfterStaff);
};

}, []);

// const listItems = staffMembers.map((member) =>
//   <li key={member.id}>
//     <img className='staff'
//   src={member.image} 
//   alt={member.name}
// style={{width: '100px', height: '100px', border: '2px solid red'}}
// />
//     {member.name}
//   </li>
// );


    return(
        <main>
            <img  src= {codeKitchenBackground} alt='CodeKitchen background'  className={`background_image ${showBackground ? 'visible' : ''} ${isBlurred ? 'blur-effect' : ''}`} />
            <h1 className={showHeading ? 'visible' : ''}>Welcome to the Code Kitchen!</h1>
            {/* <img  src= {staff} alt='CodeKitchen staff'  className={`staff ${ showStaffMembers ? 'visible' : ''} `} /> */}
            <div className={`staff_box ${showStaffMembers ? 'visible' : ''}`} >
      
              <div className="staff-member" id="brain-chef">
              <img src={brainChef} alt="Brain Chef The Mastermind" role="figure" />
              <div className="staff-name">Brain Chef The Mastermind</div>
              </div>
              <div className="staff-member" id="dotty">
              <img src={dotty} alt="Dotty The Bug Hunter" role="figure" />
              <div className="staff-name">Dotty The Bug Hunter</div>
              </div>
              <div className="staff-member" id="herb">
              <img src={herb} alt="Herb The Database Gardener" role="figure" />
              <div className="staff-name">Herb The Database Gardener</div>
              </div>
              <div className="staff-member" id="octobear">
              <img src={octoBear} alt="Octobear The Binary Baker" role="figure" />
              <div className="staff-name">Octobear The Binary Baker</div>
              </div>
              <div className="staff-member" id="patch">
              <img src={patch} alt="Patch The Http Delivery Rat" role="figure" />
              <div className="staff-name">Patch The Http Delivery Rat</div>
              </div>
              <div className="staff-member" id="tux">
              <img src={tux} alt="Tux The Systems Superintendent" role="figure" />
              <div className="staff-name">Tux The Systems Superintendent</div>
              </div>
              <div className="staff-member" id="monsieur-moustache">
              <img src={monsieurMoustache} alt="Monsieur Moustache The Code Critic" role="figure" />
              <div className="staff-name">Monsieur Moustache The Code Critic</div>
              </div>
              <div className="staff-member" id="py">
              <img src={py} alt="Py The Code Waiter" role="figure" />
              <div className="staff-name">Py The Code Waiter</div>
              </div>
              <div className="staff-member" id="retsko">
              <img src={retsko} alt="Retsko The Frontend Mixologist" role="figure" />
              <div className="staff-name">Retsko The Frontend Mixologist</div>
              </div>
              <div className="staff-member" id="soapy">
              <img src={soapy} alt="Soapy The Code Cleaner" role="figure" />
              <div className="staff-name">Soapy The Code Cleaner</div>
              </div>
            </div>
            <div className={`enter ${showEnterButton ? 'visible' : ''}`} >

            <button className='come-in' > <img className='pastry come-in' alt='cookie' src={cookie}/> Enter <img className='pastry' alt='hot chocolate' src={hot_chocolate} /> </button>

                </div>



        </main>

    )

}